import { TOASTER_TYPES } from 'components/core/Toaster/types';
import { TranslationKey } from 'intl';
import { IssueTranslationKeys } from 'intl/keys';
import { showToast } from 'services/toaster';

function showEventToast(messageKey: TranslationKey, eventTitle: string): void {
  showToast({
    message: {
      id: messageKey,
      content: eventTitle,
    },
    type: TOASTER_TYPES.SUCCESS,
  });
}

export function showEventAddedToast(eventTitle: string): void {
  showEventToast(IssueTranslationKeys.eventsNotificationAddSuccess, eventTitle);
}

export function showEventEditedToast(eventTitle: string): void {
  showEventToast(IssueTranslationKeys.eventsNotificationEditSuccess, eventTitle);
}

export function showEventRemovedToast(eventTitle: string): void {
  showEventToast(IssueTranslationKeys.eventsNotificationDeleteSuccess, eventTitle);
}
